import React, { useState } from "react";
import { ReportGrid } from "../../../components/ReportGrid"; 
import { Package, Warehouse, Calculator, TrendingUp } from "lucide-react";
import { useReportStore } from "../../../store/raporStore";
import { DatePicker } from "../../../components/DatePicker";

export const StockReports = () => {
  const [activeTab, setActiveTab] = useState<"status" | "valuation" | "performance">("status");
  const { filters, setFilters } = useReportStore();

  const statusColumns = [
    { header: "Depo", body: (row: any) => row.warehouse?.name },
    { header: "Ürün", body: (row: any) => row.stock?.name },
    { header: "Miktar", body: (row: any) => <span className="font-bold">{row.quantity} {row.stock?.unit?.name}</span> },
  ];

  const valuationColumns = [
    { header: "Stok Kodu", field: "sku" },
    { header: "Ürün Adı", field: "name" },
    { header: "Mevcut Stok", field: "currentQuantity" },
    { header: "Toplam Değer", body: (row: any) => (
      <span className="font-bold">{row.totalValue?.toLocaleString('tr-TR')} {row.currency}</span>
    )},
  ];

  const performanceColumns = [
    { header: "Stok Kodu", field: "sku" },
    { header: "Ürün Adı", field: "stockName" },
    { header: "Satış Adedi", body: (row: any) => row._sum?.quantity },
    { header: "Toplam Ciro", body: (row: any) => (
      <span className="font-bold">{row._sum?.totalAmount?.toLocaleString('tr-TR')} TRY</span>
    )},
  ];

  const PerformanceDateFilter = (
    <div className="flex items-center gap-2 no-print">
      <DatePicker
        name="startDate"
        label=""
        value={filters.startDate}
        className="min-w-48"
        onChange={(val: any) => setFilters({ ...filters, startDate: val?.target ? val.target.value : val })}
      />
      <span className="text-slate-300 font-light">/</span>
      <DatePicker
        name="endDate"
        label=""
        value={filters.endDate}
        className="min-w-48"
        onChange={(val: any) => setFilters({ ...filters, endDate: val?.target ? val.target.value : val })}
      />
    </div>
  );

  return (
    <div className="space-y-6">
      <div className="flex flex-col card lg:flex-row lg:items-center justify-between gap-4">
        <div>
          <h1 className="text-sm sm:text-2xl font-black flex items-center gap-3">
            <div className="p-2 bg-indigo-600 text-white rounded-xl shadow-lg">
              <Package size={20} />
            </div>
            Stok ve Envanter Analizi
          </h1>
          <p className="text-sm mt-1 opacity-70">Stok durumlarını ve finansal değerleri izleyin.</p>
        </div>

        <div className="flex gap-1 p-1 card rounded-xl w-fit no-print">
          <button onClick={() => setActiveTab("status")} className={`flex items-center gap-2 px-5 py-2 rounded-lg text-xs font-bold transition-all ${activeTab === "status" ? "btn-new" : ""}`}>
            <Warehouse size={16} /> Depo
          </button>
          <button onClick={() => setActiveTab("valuation")} className={`flex items-center gap-2 px-5 py-2 rounded-lg text-xs font-bold transition-all ${activeTab === "valuation" ? "btn-new" : ""}`}>
            <Calculator size={16} /> Değerleme
          </button>
          <button onClick={() => setActiveTab("performance")} className={`flex items-center gap-2 px-5 py-2 rounded-lg text-xs font-bold transition-all ${activeTab === "performance" ? "btn-new" : ""}`}>
            <TrendingUp size={16} /> Performans
          </button>
        </div>
      </div>

      <div className="mt-4">
        <div className={activeTab === "status" ? "block" : "hidden"}>
          <ReportGrid endpoint="/reports/inventory/status" columns={statusColumns} reportName="Depo Stok Durumu" />
        </div>
        <div className={activeTab === "valuation" ? "block" : "hidden"}>
          <ReportGrid endpoint="/reports/inventory/valuation" columns={valuationColumns} reportName="Envanter Değer Raporu" />
        </div>
        <div className={activeTab === "performance" ? "block" : "hidden"}>
          <ReportGrid 
            endpoint="/reports/sales/performance" 
            columns={performanceColumns} 
            filters={filters} 
            reportName="Stok Satış Performansı" 
            extraFilters={PerformanceDateFilter}
          />
        </div>
      </div>
    </div>
  );
};